import { render, staticRenderFns } from "./StatsPathToHealthView.vue?vue&type=template&id=1cb74744&scoped=true"
import script from "./StatsPathToHealthView.vue?vue&type=script&lang=js"
export * from "./StatsPathToHealthView.vue?vue&type=script&lang=js"
import style0 from "./StatsPathToHealthView.vue?vue&type=style&index=0&id=1cb74744&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb74744",
  null
  
)

export default component.exports